import React from 'react';
import whatsapp from '../assets/whatsapp.png';
import { Box } from '@mui/material';

const WhatsAppButton = () => {
  const phoneNumber = '+919705401575'; // Replace with your WhatsApp number
  const message = 'Hello! I have a question about your properties.'; // Default message

  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <Box sx={{
      position: 'fixed',
      bottom: '30px',
      right: '30px',
      zIndex: 11000,
      width: '60px',
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      borderRadius: '50%',
      
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: '#128C7E',
        transform: 'scale(1.1)'
      }
    }}
    onClick={handleClick}
    >
      <img  loading='lazy'
        src={whatsapp} 
        alt="WhatsApp" 
        style={{ 
          width: '100%', 
          height: '100%',
          objectFit: 'contain' 
        }} 
      />
    </Box>
  );
};

export default WhatsAppButton;

